<template>
  <div class="measure-grid-menu__container">
    <div id="menu-item-measure-length">
      <button
        class="measure-grid-menu__button"
        :class="{ active: measureMode === 1 }"
        title="Medir distancia"
        @click="setMeasureLength"
      >
        <span class="material-icons"> straighten </span>
      </button>
    </div>
    <div id="menu-item-measure-area">
      <button
        class="measure-grid-menu__button"
        :class="{ active: measureMode === 2 }"
        title="Medir área"
        @click="setMeasureArea"
      >
        <span class="material-icons"> square_foot </span>
      </button>
    </div>
    <div id="menu-item-grid">
      <button
        class="measure-grid-menu__button"
        :class="{ active: isGridActive }"
        title="Cuadrícula"
        @click="setGrid"
      >
        <span class="material-icons"> grid_4x4 </span>
      </button>
    </div>
    <div id="menu-item-center">
      <button
        class="measure-grid-menu__button"
        :class="{ active: isCenterActive }"
        title="Mostrar centro"
        @click="setCenter"
      >
        <span class="material-symbols-outlined"> point_scan </span>
      </button>
    </div>
  </div>
</template>

<script setup>
import {computed} from 'vue';
import {useStore} from 'vuex';
// #region Props, Emits
// #endregion

// #region Params, Ref, Reactives, Computed
const store = useStore();
const isGridActive = computed(
  () => store.getters['userLayers/isGridLayerActive'],
);
const measureMode = computed(() => store.state.map.measureMode);
const isCenterActive = computed(() => store.state.map.centerMapDraw);
// #endregion

// #region Functions
async function setMeasureLength() {
  await store.dispatch('map/setMeasureMode', 1, {root: true});
}
async function setMeasureArea() {
  await store.dispatch('map/setMeasureMode', 2, {root: true});
}
async function setGrid() {
  if (!!isGridActive?.value) {
    return store.dispatch('userLayers/cleanGridLayers', {root: true});
  }
  return store.dispatch('userLayers/addGridLayer', {gridType: '1'}, {root: true});
}
async function setCenter() {
  if (!!isCenterActive?.value) {
    return store.dispatch('map/setCenterMapDraw', false, {root: true});
  }
  return store.dispatch('map/setCenterMapDraw', true, {root: true});
}
// #endregion

// #region Effects, Hooks

// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped>
@import "src/styles";
.measure-grid-menu {
  &__container {
    position: absolute;
    top: 0.8rem;
    left: 0.8rem;
    @include min-screen-width($brand__breakpoint--md) {
      top: calc(0.8rem + $overviewmap-height);
    }
    @include max-screen-height($brand__breakpoint--sm) {
      top: 0.8rem !important;
    }
  }
  &__button {
    width: 40px;
    height: 40px;
    border-radius: 20%;
    background-color: $brand__color--blue !important;
    color: white;
    border: 2px solid white;
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
    outline: none;
    &.active {
      background-color: yellow !important;
      color: black;

      .material-icons {
        color: black !important;
      }
    }
  }
}
</style>
